// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application";
import "daisyui";

import ApplicationController from "./application_controller.js";
// application.register("application", ApplicationController);

import FlashController from "./flash_controller";
application.register("flash", FlashController);

import ConfirmController from "./confirm_controller";
application.register("confirm", ConfirmController);

import GalleryController from "./gallery_controller";
application.register("gallery", GalleryController);

import AdformController from "./adform_controller";
application.register("adform", AdformController);

import QuickadController from "./quickad_controller";
application.register("quickad", QuickadController);

import StudentscsvController from "./studentscsv_controller";
application.register("studentscsv", StudentscsvController);

import FilterController from "./filter_controller";
application.register("filter", FilterController);

import ChangelogController from "./changelog_controller";
application.register("changelog", ChangelogController);
